import { Position, Rect } from 'types'

export function rectFromPosition(position: Position): Rect {
    return {
        bottom: position.y + position.height,
        left: position.x,
        right: position.x + position.width,
        top: position.y,
    }
}
